import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=b8e964c0"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8e964c0')) {
      api.createRecord('b8e964c0', component.options)
    } else {
      api.reload('b8e964c0', component.options)
    }
    module.hot.accept("./Filters.vue?vue&type=template&id=b8e964c0", function () {
      api.rerender('b8e964c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Views/Transito/components/Filters.vue"
export default component.exports